(() => {
  'use strict';
  const checkoutPath = '/vi-vn/pages/qr-checkout';
  const selectors = '[data-flqr-entry],button[name="checkout"],input[name="checkout"],a[href="/checkout"],a[href="/vi-vn/checkout"]';
  const attributionKey = 'flashlabel-vn-qr-attribution-v1';
  const currentAttribution = {};
  for (const [key,value] of new URLSearchParams(location.search)) {
    if (/^utm_(source|medium|campaign|content|term)$/.test(key)) currentAttribution[key] = value.slice(0,200);
  }
  if (Object.keys(currentAttribution).length) {
    try { sessionStorage.setItem(attributionKey,JSON.stringify({values:currentAttribution,time:Date.now()})); } catch (_) { /* optional */ }
  }
  const transferAttribution = () => {
    const params = new URLSearchParams();
    try {
      const saved = JSON.parse(sessionStorage.getItem(attributionKey));
      if (saved && Date.now() - saved.time < 2 * 60 * 60 * 1000) {
        for (const [key,value] of Object.entries(saved.values)) params.set(key,value);
      }
    } catch (_) { /* optional */ }
    for (const [key,value] of new URLSearchParams(location.search)) {
      if (/^utm_(source|medium|campaign|content|term)$/.test(key)) params.set(key,value.slice(0,200));
    }
    const query = params.toString();
    return checkoutPath + (query ? '?' + query : '');
  };
  window.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest(selectors) : null;
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(transferAttribution());
  }, true);
  window.addEventListener('submit', (event) => {
    if (event.submitter && event.submitter.matches('[name="checkout"]')) {
      event.preventDefault(); event.stopImmediatePropagation(); location.assign(transferAttribution());
    }
  }, true);
})();
